import { initializeFormAction } from "../context/actions/initializeFormAction";
import {apiHost, getwayApi} from "../config/Constants";
import axios from "axios";
import {localFormSpec} from '../UI/configTest'
import {testFormSpec} from '../context/formSpec_patient.js'

export const fetchFormData = async (setError, setLoading, session, dispatch) => {
    setError(false);
    setLoading(true);

    try {
      await axios.get(`${getwayApi}/api/session/client/${session.id}`).then(response => {
        // GET call is made to endpoint with query string appended
        
        const responseData = response.data;
        const dbFormSpec = JSON.parse(response.data.formSpecs);
        const formId = response.data.formId;
        const formType = response.data.formType.trim();
        window.location.host.includes('localhost') && console.log("FORM TYPE:", formType)
        
        dispatch( 
            initializeFormAction(session, responseData, localFormSpec, dbFormSpec, formId, formType) 
          );
          // the session object, formSpecs, and other form/org data, are stored on the formInfo state binding.
          // TO-DO: Replace configTest with the formSpec that's returned by the response.
          setLoading(false);
        })
        
        .catch(err => {
          setLoading(false);
          console.log('error:', err)
          setError(err);
        });
      } catch (error) {
        setLoading(false);
        console.log(error)
        setError(error);
    }
  };

  export const submitFileData = (url, session) => {
    return async (file) => {
      const fileReader = new FileReader();
      
      function getByteArray(file) {
        return new Promise(function(resolve, reject) {
          fileReader.readAsArrayBuffer(file);
          fileReader.onload = function(ev) {
            const array = new Uint8Array(ev.target.result);
            const fileByteArray = [];
            for (let i = 0; i < array.length; i++) {
              fileByteArray.push(array[i]);
            }
            resolve(fileByteArray);  // successful
          }
          fileReader.onerror = reject; // call reject if error
        })
      }
      
      let submissionPayload = new FormData();
      submissionPayload.append("fileName", file.name);
      submissionPayload.append("contentType", file.type);
      submissionPayload.append("sessionId", session);
      submissionPayload.append("fileByte",  file);
      
      await axios
      .post(`${url}/api/session/supportingdoc/upload`, submissionPayload, {headers: {'Content-Type': 'multipart/form-data'}})
      .then(res => {
        
      })
      .catch(err => {
        if(err.response !== undefined)
        console.log(err.response)            
      });
    }
  }
  
  export const deleteFileData = (url, session) => {
    return async (filename) => {
      //api/session/supportingdoc/remove/{sessionId}/{filename}
      
      await axios
      .delete(`${url}/api/session/supportingdoc/remove/${session}/${filename}`)
      .then(res => {
        
      })
      .catch(err => {
        if(err.response !== undefined)
        console.log(err.response)            
      });
      
    }
  }
  
  export const submitUserData = (url, session, esign, organization, formid, setNextPage, setSubmissionError) => {
    return async (formData, actions) => {
      
      // setNextPage(true);
      
      let submissionPayload;
      let fileData;
      let subData = formData;
      delete subData.dosFrom1
      delete subData.dosTo1
      delete subData.PDOB1
      
      // if user has elected not to upload a document, remove the placeholder object used to bypass the form validation
      !formData.supportingDoc[0] || !formData.supportingDoc[0].type && formData.supportingDoc.splice(0,1);
      
      const config = {headers: {'content-type': 'multipart/form-data'}}
      // subData.esign = esign;
      // subData.releaseFromDate = subData.releaseFromDate.toDateString();
      // subData.releaseToDate = subData.releaseToDate.toDateString();
      // subData.patientInfoDob = subData.patientInfoDob.toDateString();
      subData.session = session;
      subData.organizationId = organization;
      subData.formId = formid;
      
      if(subData.supportingDoc){
        submissionPayload = new FormData();
        let counter = 1;
        fileData = subData.supportingDoc.map(x => {
          submissionPayload.append(`medFile${counter}`, x)
          counter++;
          return {
            name: x.name,
            type: x.type,
            size: x.size
          }
        });
        submissionPayload.append('vra1', true);
        
        
        subData.fileData = fileData;
        
        delete subData.supportingDoc;
        
        submissionPayload.append('userData', JSON.stringify(subData));
        
        
      }else{
        submissionPayload = {data: JSON.stringify(subData)}
        config = {headers: {'content-type': 'application/json'}}
      }
      
      // create file data object
      // list of files
      const apiUrl = `${url}/api/submission/v2`;
      let currentTimeStamp = new Date().getTime();
      let submissionURL = `${apiUrl}?_=${currentTimeStamp}`

      
      
      await axios
      .post(submissionURL, submissionPayload, config)
      .then(res => {
        window.location = `${apiHost}/patient/patientConfirmationPage/?session=${session}&_=${currentTimeStamp}`;
        
      })
      .catch(err => {
        if(err.response !== undefined)
        console.log(err.response)
        console.log(err)
        setSubmissionError({status: true, info: err.response})

        
        // TODO; map infrastructure error to domain error
        
      });
    }
  }

  export const fetchCaptcha = async (captchaUrl, setCaptchaRespObj) => {
    
    try {
      // NOTE; axios is currently pointing to file system json file.  Use the router match prop to construct the appropriate url
      // to retrieve the configuration (and pesisted form state specific to the session if it is a back request)
      // simulating userState example below
      
      

      await axios
      .get(`${captchaUrl}/api/captcha`)
        .then(res => {
          setCaptchaRespObj(res.data)
        })
        .catch(err => {});
      } 
      catch (error) {
        console.log(error)
      }
  };

  export const submitCaptchaData = async (captchaUrl, captchaRespObj, userCatchaInput, setCaptcha, setErrorState) => {
         
    
    try {
      // NOTE; axios is currently pointing to file system json file.  Use the router match prop to construct the appropriate url
      // to retrieve the configuration (and pesisted form state specific to the session if it is a back request)
      // simulating userState example below

      await axios
      .post(`${captchaUrl}/api/captcha/${captchaRespObj.id}/match/${userCatchaInput}`)
        .then(res => {
          setCaptcha(res.data)
          if(!res.data){
            console.log("bad captcha")
            setErrorState(true)
          }
         
        })
        .catch(err => {
           console.log("bad captcha")
            setErrorState(true)
           
        });
      } catch (error) {
        console.log("bad captcha")
        setErrorState(true)
    }
  };